import React from "react";

import { useHistory } from "react-router-dom";

import "./DashboardLink.scss";

const DashboardLink = ({text, icon, link}) => {
  const history = useHistory();

  return (
      <div className="dashboard-link" onClick={() => {history.push(link)}}>
        <div className="green-circle"><img alt={text} src={icon} /></div>
        {text}
      </div>
  );
};

export default DashboardLink;